import Swal from "sweetalert2";
import {log} from "@/state/pinia/log";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



export const suppliersHelperMethods = {

    refreshLocalSuppliersList(rowActions,drugstoresLocalSuppliersVisibleHeadersTitlesMap,suppliersVisibleHeaders,currentPage,sortingKey,sortingDirection,searchRequest,showOnlyUnBound,boundWithCentralGuid) {
        const commonAppModule = useCommonAppModule()
        const lazyloader = useLazyLoaderModule()
        lazyloader.setDisplayLazyLoader(true);
        lazyloader.setProgressBarMessage("Pobieranie listy lokalnych dostawców aptek.");
        commonAppModule.setRawDrugstoresSuppliersData([]);


        var availableHeaders = JSON.parse(JSON.stringify(commonAppModule.getRawDrugstoresSuppliersHeaders)).filter(header => suppliersVisibleHeaders.includes(header.key));

        var searchAndFilterRequest = {
            fields: null,
            search: searchRequest,
            filters: null
        }

        var payload = {
            searchAndFilterRequest: searchAndFilterRequest,
            currentPage: currentPage,
            sortingDirection: sortingDirection,
            sortingKey: sortingKey,
            showOnlyUnBound: showOnlyUnBound,
            boundWithCentralGuid: boundWithCentralGuid

        };

        return commonAppModule.httpGetRawDrugstoresSuppliersDataPaging(payload).then(() => {

            var localSuppliersRows = [];
            var suppliers = JSON.parse(JSON.stringify(commonAppModule.getRawDrugstoresSuppliersData));
            for (var i = 0; i < suppliers.length; i++) {


                suppliers[i]["tooltip"] = commonAppModule.getDrugstoresNameMap[suppliers[i]["id_apteki"]];
                suppliers[i]["nazwa_apteki"] = commonAppModule.getDrugstoresNameMap[suppliers[i]["id_apteki"]];
                if (suppliers[i]["id_kartoteki_centralnej_dostawcy"] != null) {
                    suppliers[i]["nazwa_kartoteki_centralnej_dostawcy"] = "[" + suppliers[i]["id_kartoteki_centralnej_dostawcy"] + "] " + suppliers[i]["nazwa_kartoteki_centralnej_dostawcy"];
                }
                localSuppliersRows.push(suppliers[i]);
            }

            var localSupplierHeaders = []


            for (var j = 0; j < suppliersVisibleHeaders.length; j++) {
                var header = availableHeaders.find(header => header.key === suppliersVisibleHeaders[j]);
                if (header !== undefined) {
                    header["text"] = drugstoresLocalSuppliersVisibleHeadersTitlesMap[suppliersVisibleHeaders[j]];
                    // setting type on data_row_id and id_apteki column to number style
                    if (header.key === "data_row_id" || header.key === "id_apteki" || header.key === "id_kamsoft_dost") {
                        header["class"] = "sticky-header col-number";
                    } else if (header.key === "nazwa_kartoteki_centralnej_dostawcy") {
                        header["sortable"] = false;
                    }

                    localSupplierHeaders.push(header);
                }
            }

            localSupplierHeaders.push(
                {
                    text: "Akcje",
                    key: "actions",
                    type: "actions",
                    style: "cursor:pointer;",
                    actions: rowActions

                }
            );

            // adding row actions
            for (var k = 0; k < localSuppliersRows.length; k++) {
                const bindButtonsClass = suppliersHelperMethods.getBindCentralSupplierActionClass(localSuppliersRows[k]);
                localSuppliersRows[k]["actions"] = [
                    {
                        text: "Usuń powiązanie",
                        icon: "fas fa-times",
                        action: "remove-central-supplier-binding",
                        class: suppliersHelperMethods.getUnbindCentralSupplierActionClass(localSuppliersRows[k]),
                        enabled: true,
                        tooltip: "Usuń powiązanie z centralnym dostawcą",
                    },
                    {
                        text: "",
                        icon: "fas fa-link",
                        action: "bind-with-central-supplier",
                        class: bindButtonsClass,
                        enabled: true,
                        tooltip: "Powiąż z centralnym dostawcą",
                    },
                    {
                        text: "",
                        icon: "fas fa-sync-alt",
                        action: "create-bind-with-central-supplier",
                        class: bindButtonsClass,
                        enabled: true,
                        tooltip: "Powiąż automatycznie",
                    },
                ];

            }

            var resultPayload = {
                availableHeaders: availableHeaders,
                localSuppliersRows: localSuppliersRows,
                localSupplierHeaders: localSupplierHeaders
            }

            return new Promise((resolve) => {
                resolve(resultPayload);
            });


        });
    },
    showBindWithCentralSupplierModal(items, rowIdentifierKey, localSuppliersRows) {
        var boundItems = 0
        for (var i = 0; i < items.length; i++) {
            var rowIdentifier = items[i];
            var suppliersFound = localSuppliersRows.find(row => row[rowIdentifierKey] === rowIdentifier); // there should be always only one supplier for DATA_ROW_ID
            if (suppliersHelperMethods.isLocalSupplierBound(suppliersFound)) {
                boundItems++;
            }

        }
        var resultPayload = {
            showSelectCentralSupplierModal: false,
        }
        if (boundItems > 0) {
            return suppliersHelperMethods.showExistingBindingsWarningModal().then((result) => {
                if (result.isConfirmed) {
                    resultPayload.showSelectCentralSupplierModal = true;
                    return new Promise((resolve) => {
                        resolve(resultPayload);
                    });
                }else{
                    resultPayload.showSelectCentralSupplierModal = false;
                    return new Promise((resolve) => {
                        resolve(resultPayload);
                    });
                }
            });
        } else {
            resultPayload.showSelectCentralSupplierModal = true;
            return new Promise((resolve) => {
                resolve(resultPayload);
            });
        }
    },
    showExistingBindingsWarningModal(){
        return Swal.fire({
            title: "Istnieją powiązania dla niektórych dostawców",
            text: "Pośród zaznaczonych dostawców istnieją tacy, którzy mają już powiązanie z centralnymi kartotekami dostawców. Czy na pewno chcesz powiązać tych dostawców z inną kartoteka centralną?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Nie",
            confirmButtonText: "Tak",
            customClass: {
                container: "swal-highest"
            },
        });
    },

    refreshFieldsAvailableForSearch(availableHeaders,drugstoresLocalSuppliersVisibleHeadersTitlesMap) {
        const commonAppModule = useCommonAppModule()
        const lazyloader = useLazyLoaderModule()
        return commonAppModule.httpGetRawDrugstoresSuppliersSearchKeys().then(() => {
            var fieldsAvailableForSearch = [];
            var searchKeysFetched = JSON.parse(JSON.stringify(commonAppModule.getRawDrugstoresSuppliersSearchKeys));
            var tableColumnsAvailableForSearch = availableHeaders.filter(header => searchKeysFetched.includes(header.key) && header.type === "text");
            for (var i = 0; i < tableColumnsAvailableForSearch.length; i++) {

                fieldsAvailableForSearch.push({
                    name: drugstoresLocalSuppliersVisibleHeadersTitlesMap[tableColumnsAvailableForSearch[i].key],
                    key: tableColumnsAvailableForSearch[i].key
                });
            }
            var fieldsAvailableForSearchPayload = {
                fieldsAvailableForSearch: fieldsAvailableForSearch
            }

            return new Promise((resolve) => {
                resolve(fieldsAvailableForSearchPayload);
            });
        });



    },

    getUnbindCentralSupplierActionClass(row) {
        if (suppliersHelperMethods.isLocalSupplierBound(row)) {
            return "btn btn-warning table-actions-button edit-button";
        } else {
            return "element-not-visible";
        }

    },

    isLocalSupplierBound(row) {
        var boundCentralSupplieName = row["nazwa_kartoteki_centralnej_dostawcy"]
        if (boundCentralSupplieName === null || boundCentralSupplieName === undefined || boundCentralSupplieName === "") {
            return false;
        } else {
            return true;
        }
    },

    getBindCentralSupplierActionClass(row) {
        if (suppliersHelperMethods.isLocalSupplierBound(row)) {
            return "element-not-visible";
        } else {
            return "btn btn-success table-actions-button edit-button";
        }

    },


    autoBindSuppliers() {
        return Swal.fire({
            title: "Powiązywanie dostawców",
            text: "Nastąpi próba powiązania, niepowiązanych dotychczas lokalnych kartotek dostawców z centralnymi kartotekami dostawców. Czy chcesz rozpocząć proces?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Nie",
            confirmButtonText: "Tak",
            customClass: {
                container: "swal-highest"
            },
        }).then((result) => {
            if (result.isConfirmed) {
                const commonAppModule = useCommonAppModule()
                const lazyloader = useLazyLoaderModule()
                lazyloader.setDisplayLazyLoader(true);
                lazyloader.setProgressBarMessage("Auto powiązywanie loklanych kartotek...");
                return commonAppModule.httpAutoBindLocalSuppliers();
            }else{
                return new Promise((resolve) => {
                    resolve();
                });
            }
        });
    },
    bindWithSupplier(localIdsSelected,rowIdentifierKey,currentSelectedLocalSupplierData,selectedCentralSupplierGuidToBind) {
        if (selectedCentralSupplierGuidToBind == null) {
            Swal.fire({
                title: "Brak centralnego dostawcy",
                text: "Nie wybrano centralnego dostawcy do powiązania.",
                icon: "info",
                confirmButtonText: "OK",
                customClass: {
                    container: "swal-highest"
                },
            });
            return new Promise((resolve) => {
                resolve({isConfirmed: false});
            });
        } else {
            const commonAppModule = useCommonAppModule()
            const lazyloader = useLazyLoaderModule()
            lazyloader.setDisplayLazyLoader(true);
            lazyloader.setProgressBarMessage("Powiązywanie loklanych kartotek...");

            var localIdsToBind = localIdsSelected;
            if (currentSelectedLocalSupplierData != null) {
                localIdsToBind = [currentSelectedLocalSupplierData[rowIdentifierKey]];
            }

            var payload = {
                localIds: localIdsToBind,
                centralSupplierGuid: selectedCentralSupplierGuidToBind
            }

            return commonAppModule.httpBindLocalSuppliersIds(payload)

        }


    },

    unBindCentralSupplier(localIds, rowIdentifierKey, localSuppliersRows) {
        var suppliersSelected = localSuppliersRows.filter(row => localIds.includes(row[rowIdentifierKey]));
        var suppliersBound = suppliersSelected.filter(row => suppliersHelperMethods.isLocalSupplierBound(row));

        if (suppliersBound.length === 0) {
            Swal.fire({
                title: "Brak powiązań",
                text: "Nie odnaleziono powiązań dla zaznaczonych dostawców.",
                icon: "info",
                confirmButtonText: "OK",
                customClass: {
                    container: "swal-highest"
                },
            });
            return new Promise((resolve) => {
                resolve({isConfirmed: false});
            });
        } else {

            return Swal.fire({
                title: "Usuwanie powiązania",
                text: "Czy na pewno chcesz usunąć powiązanie z centralnym dostawcą?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: "Nie",
                confirmButtonText: "Tak",
                customClass: {
                    container: "swal-highest"
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    const commonAppModule = useCommonAppModule()
                    const lazyloader = useLazyLoaderModule()
                    lazyloader.setDisplayLazyLoader(true);
                    lazyloader.setProgressBarMessage("Usuwanie powiązań loklanych kartotek...");
                    var payload = {
                        localIds: localIds,
                    }

                    return commonAppModule.httpUnbindLocalSuppliersIds(payload).then(() => {
                        return new Promise((resolve) => {
                            resolve({isConfirmed: true});
                        });

                    });
                } else {
                    return new Promise((resolve) => {
                        resolve({isConfirmed: false});
                    });
                }
            });
        }


    },

    createAndBindSuppliers(localIdsToBind) {
        return Swal.fire({
            title: "Powiązywanie automatyczne",
            text: "Nastąpi próba utworzenia i/lub powiązania, niepowiązanych dotychczas lokalnych kartotek dostawców z centralnymi kartotekami dostawców. Czy chcesz rozpocząć proces?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Nie",
            confirmButtonText: "Tak",
            customClass: {
                container: "swal-highest"
            },
        }).then((result) => {
            if (result.isConfirmed) {
                var payload = {
                    localIds: localIdsToBind,
                }
                log.log(payload);
                const commonAppModule = useCommonAppModule()
                const lazyloader = useLazyLoaderModule()
                lazyloader.setDisplayLazyLoader(true);
                lazyloader.setProgressBarMessage("Tworzenie i powiązywanie loklanych kartotek...");
                return commonAppModule.httpCreateOrBindLocalSuppliersIds(payload);

            } else {
                return new Promise((resolve) => {
                    resolve();
                });
            }
        });
    },

    showLocalSupplierDetails(localSupplierTableItem, rowIdentifierKey, localSuppliersRows) {
        var rowIdentifier = localSupplierTableItem[rowIdentifierKey];
        var suppliersFound = localSuppliersRows.find(row => row[rowIdentifierKey] === rowIdentifier); // there should be always only one supplier for DATA_ROW_ID
        var responsePayload = {
            supplierDetailsModalTitle: "Brak danych dostawcy ",
            showSelectCentralSupplierModal: false,
            currentSelectedLocalSupplierData: null
        }

        if (suppliersFound != null) {
            responsePayload.currentSelectedLocalSupplierData = JSON.parse(JSON.stringify(suppliersFound));
            if (responsePayload.currentSelectedLocalSupplierData["actions"] != null) {
                delete responsePayload.currentSelectedLocalSupplierData["actions"];
            }
            responsePayload.supplierDetailsModalTitle = "Dane dostawcy: " + suppliersFound["nazwa_dostawcy"];
            responsePayload.showLocalDrugstoresSuppliersModal = true;
            return new Promise((resolve) => {
                resolve(responsePayload);
            });

        } else {
            return suppliersHelperMethods.showNoSupplierDataWarning(rowIdentifier);
        }

    },

    bindWithCentralSupplier(localSupplierTableItem, rowIdentifierKey, localSuppliersRows) {
        // open modal with central suppliers list (one choice list)

        var rowIdentifier = localSupplierTableItem[rowIdentifierKey];
        var suppliersFound = localSuppliersRows.find(row => row[rowIdentifierKey] === rowIdentifier); // there should be always only one supplier for DATA_ROW_ID
        var responsePayload = {
            showSelectCentralSupplierModal: false,
            currentSelectedLocalSupplierData: null
        }
        if (suppliersFound != null) {

            if (suppliersHelperMethods.isLocalSupplierBound(suppliersFound)) {
                Swal.fire({
                    title: "Powiązanie już istnieje",
                    text: "Powiązanie tego dostawcy lokalnego z kartoteką centralną dostawcy już istnieje, czy na pewno chcesz powiązać tego dostawce z inną kartoteka centralną?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    cancelButtonText: "Nie",
                    confirmButtonText: "Tak",
                    customClass: {
                        container: "swal-highest"
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        responsePayload.showSelectCentralSupplierModal = true;
                        responsePayload.currentSelectedLocalSupplierData = JSON.parse(JSON.stringify(suppliersFound));
                        return new Promise((resolve) => {
                            resolve(responsePayload);
                        });
                    } else {
                        responsePayload.showSelectCentralSupplierModal = false;
                        responsePayload.currentSelectedLocalSupplierData = null;
                        return new Promise((resolve) => {
                            resolve(responsePayload);
                        });
                    }
                });
            } else {

                responsePayload.showSelectCentralSupplierModal = true;
                responsePayload.currentSelectedLocalSupplierData = JSON.parse(JSON.stringify(suppliersFound));
                return new Promise((resolve) => {
                    resolve(responsePayload);
                });
            }

        } else {
            responsePayload.showSelectCentralSupplierModal = false;
            responsePayload.currentSelectedLocalSupplierData = null;
            return new Promise((resolve) => {
                resolve(responsePayload);
            });
        }
    },

    showNoSupplierDataWarning(localSupplierTableItem) {
        return Swal.fire({
            title: "Brak dostawcy",
            text: "Nie odnaleziono dostawcy o ID lokalnym " + localSupplierTableItem,
            icon: "info",
            confirmButtonText: "OK",
            customClass: {
                container: "swal-highest"
            },
        });
    },


};
